import React, { useEffect, useState } from 'react';
import { recolorOrangeToGreen } from '../../utils/recolorImage';
import type { SlideProps } from './SlideShell';
interface ReferenceImageSlideProps extends SlideProps {
  src: string;
  alt: string;
  recolorOrange?: boolean;
}
export function ReferenceImageSlide({
  src,
  alt,
  recolorOrange = false
}: ReferenceImageSlideProps) {
  const [renderedSrc, setRenderedSrc] = useState<string | null>(recolorOrange ? null : src);
  useEffect(() => {
    let active = true;
    if (!recolorOrange) {
      setRenderedSrc(src);
      return () => {
        active = false;
      };
    }
    setRenderedSrc(null);
    recolorOrangeToGreen(src).then(result => {
      if (active) setRenderedSrc(result);
    }).catch(() => {
      if (active) setRenderedSrc(src);
    });
    return () => {
      active = false;
    };
  }, [recolorOrange, src]);
  return <div className="flex h-full w-full items-center justify-center overflow-hidden bg-[var(--bg)]" data-id="element-45" data-mp="girkf227maio">
      {renderedSrc ? <img src={renderedSrc} alt={alt} className="h-full w-full object-contain" data-id="element-46" data-mp="27xdwjjurk5p0" /> : <div role="img" aria-label={alt} className="h-full w-full animate-pulse bg-[var(--bg)]" data-id="element-47" data-mp="2byz2smcsllq8" />}
    </div>;
}